import React, { useState, useEffect } from 'react';
import { Client, ClientDraft, Gender } from '../types';

interface ClientFormProps {
  onSave: (client: ClientDraft) => void;
  onClose: () => void;
  existingClient?: Client | null;
}

export const ClientForm: React.FC<ClientFormProps> = ({ onSave, onClose, existingClient }) => {
  const [name, setName] = useState('');
  const [gender, setGender] = useState<Gender>(Gender.Femme);
  const [contact, setContact] = useState('');

  useEffect(() => {
    if (existingClient) {
      setName(existingClient.name);
      setGender(existingClient.gender);
      setContact(existingClient.contact || '');
    }
  }, [existingClient]);

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (!name.trim()) {
      return;
    }
    const clientData: ClientDraft = {
      id: existingClient?.id,
      name,
      gender,
      contact,
    };
    onSave(clientData);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white dark:bg-slate-800 rounded-lg shadow-xl w-full max-w-md">
        <h2 className="text-xl font-bold p-4 bg-brand-primary text-white rounded-t-lg">
          {existingClient ? 'Modifier le Client' : 'Nouveau Client'}
        </h2>
        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div>
            <label htmlFor="name" className="block text-sm font-medium t-text-secondary">
              Nom complet
            </label>
            <input
              id="name"
              type="text"
              value={name}
              onChange={(event) => setName(event.target.value)}
              className="t-input mt-1"
              required
            />
          </div>
          <div>
            <label htmlFor="gender" className="block text-sm font-medium t-text-secondary">
              Genre
            </label>
            <select
              id="gender"
              value={gender}
              onChange={(event) => setGender(event.target.value as Gender)}
              className="t-input mt-1"
            >
              <option value={Gender.Femme}>Femme</option>
              <option value={Gender.Homme}>Homme</option>
            </select>
          </div>
          <div>
            <label htmlFor="contact" className="block text-sm font-medium t-text-secondary">
              Contact (Telephone, etc.)
            </label>
            <input
              id="contact"
              type="text"
              value={contact}
              onChange={(event) => setContact(event.target.value)}
              className="t-input mt-1"
            />
          </div>
          <div className="flex justify-end space-x-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 bg-gray-200 dark:bg-slate-700 text-gray-800 dark:text-slate-200 rounded-md hover:bg-gray-300 dark:hover:bg-slate-600"
            >
              Annuler
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-brand-secondary text-white rounded-md hover:bg-brand-accent"
            >
              Enregistrer
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
